type dataSaved = 'me'

export const setLocalData = (key: dataSaved, value: string | number | object | boolean): void => {
  if (typeof window === 'undefined') return

  localStorage.setItem(key, JSON.stringify(value))
}

export const getLocalData = <T extends string | number | object | boolean>(key: dataSaved): T | null => {
  if (typeof window === 'undefined') return null

  const data = localStorage.getItem(key)
  return data ? (JSON.parse(data) as T) : null
}

export const removeLocalData = (key: dataSaved): void => {
  localStorage.removeItem(key)
}
